import { render } from "./SectionLeaveReport.vue?vue&type=template&id=09610e02&scoped=true"
import script from "./SectionLeaveReport.vue?vue&type=script&lang=js"
export * from "./SectionLeaveReport.vue?vue&type=script&lang=js"

import "./SectionLeaveReport.vue?vue&type=style&index=0&id=09610e02&scoped=true&lang=css"

import exportComponent from "/Users/alvinvergara/Developer/Lead Dev - Projects/DAP/iwc_dap/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09610e02"]])

export default __exports__